import FlowContentBox from "@mittwald/flow-components/dist/components/ContentBox";
import styled from "styled-components";

export const ContentBox = styled(FlowContentBox)`
  overflow: hidden;
`;

export default ContentBox;
